"use client";

import React from "react";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Link } from "@/components/common/Link";
import { Separator } from "@/components/ui/separator";
function FooterNavigation() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted animate-pulse rounded-sm" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return null;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-sm text-muted-foreground hover:text-accent transition-colors duration-200">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
export default function Footer() {
  const currentYear = new Date().getFullYear();
  return <section id="footer" className="dark bg-background text-foreground py-16 px-6 md:px-12 lg:px-24">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8 mb-16">
          
          {}
          <div className="flex flex-col items-start">
            <Link to="/" className="mb-6 inline-block">
              <WvcLogo className="h-7 w-auto text-foreground" />
            </Link>
            <p className="text-sm text-muted-foreground leading-relaxed max-w-xs">
              Validate, build, and scale with the right support behind you. A venture studio, founder platform, and strategic consulting firm.
            </p>
          </div>

          {}
          <div>
            <h3 className="text-xs font-default font-semibold tracking-widest text-foreground mb-6 uppercase">
              Navigation
            </h3>
            <MenuProvider menu_id="46">
              <FooterNavigation />
            </MenuProvider>
          </div>

          {}
          <div>
            <h3 className="text-xs font-default font-semibold tracking-widest text-foreground mb-6 uppercase">
              Inquiries
            </h3>
            <ul className="flex flex-col gap-3 text-sm text-muted-foreground">
              <li data-index={0}>
                <span className="block text-foreground mb-1">Studio</span>
                <Link to="#" className="hover:text-accent transition-colors duration-200">Apply for Partnership</Link>
              </li>
              <li data-index={1}>
                <span className="block text-foreground mb-1 mt-2">Basecamp</span>
                <Link to="https://brandbasecamp.io" newTab className="hover:text-accent transition-colors duration-200">Explore Platform</Link>
              </li>
              <li data-index={2}>
                <span className="block text-foreground mb-1 mt-2">Consulting</span>
                <Link to="#" className="hover:text-accent transition-colors duration-200">Request Advisory</Link>
              </li>
              <li data-index={3} className="mt-4">
                <Link to="mailto:info@1066ventures.com" className="hover:text-accent transition-colors duration-200">
                  info@1066ventures.com
                </Link>
              </li>
            </ul>
          </div>

          {}
          <div>
            <h3 className="text-xs font-default font-semibold tracking-widest text-foreground mb-6 uppercase">
              Connect & Legal
            </h3>
            <ul className="flex flex-col gap-3 text-sm text-muted-foreground">
              <li data-index={0}>
                <Link to="#" className="hover:text-accent transition-colors duration-200 uppercase tracking-wider text-xs">
                  LinkedIn
                </Link>
              </li>
              <li data-index={1}>
                <Link to="#" className="hover:text-accent transition-colors duration-200 uppercase tracking-wider text-xs">
                  Twitter
                </Link>
              </li>
              <li data-index={2} className="mt-4">
                <Link to="#" className="hover:text-accent transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
              <li data-index={3}>
                <Link to="#" className="hover:text-accent transition-colors duration-200">
                  Terms of Service
                </Link>
              </li>
            </ul>
          </div>

        </div>

        {}
        <Separator className="bg-border/40 mb-8" />
        
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground/60">
          <p>© {currentYear} 1066 Ventures. All rights reserved.</p>
          <p>Designed with understated elegance.</p>
        </div>
      </div>
    </section>;
}